<mat-card
  class="alarm"
  [class.alarm_is-flipped]="isFlipped"
  [class.alarm_is-dronesense]="alarm.type === 'DroneSense'"
  [class.isClosed]="isClosed"
>
  <header class="alarm__header">
    <div class="alarm__type" *ngIf="alarmIcon">
      <sn-icon
        [fontIcon]="alarmIcon"
        fontSet="fs"
        class="alarm__type__icon"
        *ngIf="alarmIcon"
      ></sn-icon>
    </div>

    <div class="alarm__top_row_container">
      <mat-card-title class="alarm__title">
        {{ alarm.details.cameraName ? alarm.details.cameraName : alarm.type }}
      </mat-card-title>

      <mat-card-subtitle class="alarm__closed_label" *ngIf="isClosed">(CLOSED)</mat-card-subtitle>
    </div>

    <mat-card-subtitle *ngIf="alarm.sourceInfo" class="alarm__subtitle">
      <sn-icon size="sm" class="small-icon">{{ alarm.sourceInfo.icon }}</sn-icon>
      {{ alarm.sourceInfo.name }}
    </mat-card-subtitle>

    <div class="alarm__actions">
      <sn-icon-button
        *ngIf="!hideActions"
        [matMenuTriggerFor]="alertMenu"
        [matMenuTriggerData]="{ alarm: alarm }"
        (click)="$event.stopPropagation()"
      >
        <sn-icon>more_vert</sn-icon>
      </sn-icon-button>
      <sn-icon-button
        *ngIf="canChangeAlarms && alarm.type === 'RT ALPR' && !hideActions"
        icon="clear"
        color="danger"
        matTooltip="Close Alert"
        (click)="close(alarm)"
      >
      </sn-icon-button>
    </div>
  </header>

  <mat-card-content class="alarm__content">
    <div class="alarm__preview" *ngIf="alarm.type !== 'Amber Alert'">
      <ng-template [ngIf]="recordingUrl" [ngIfElse]="thumbnail">
        <div class="alarm__preview__player">
          <!-- DroneSense iframe -->
          <iframe
            *ngIf="isDroneSenseViewer"
            class="embed-iframe"
            [src]="recordingUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
            height="200px"
          ></iframe>

          <!-- Regular video player -->
          <sn-video-player
            *ngIf="!isDroneSenseViewer"
            [src]="recordingUrl"
            [muted]="true"
            [live]="false"
            [autoplay]="alarm.autoplay"
            [controls]="true"
            [aspectRatio]="ASPECT_RATIO.Classic"
            width="100%"
          >
            <sn-player-footer-row>
              <sn-player-progress-bar-control></sn-player-progress-bar-control>
            </sn-player-footer-row>
            <sn-player-footer-row>
              <sn-player-footer-section>
                <sn-player-play-control></sn-player-play-control>
                <sn-player-volume-control></sn-player-volume-control>
                <sn-player-source-toggle-control></sn-player-source-toggle-control>
                <sn-player-time-control></sn-player-time-control>
              </sn-player-footer-section>
              <sn-player-footer-section alignment="end">
                <sn-player-fullscreen-control></sn-player-fullscreen-control>
              </sn-player-footer-section>
            </sn-player-footer-row>
          </sn-video-player>
        </div>

        <ng-template [ngIf]="alarm.source && alarm.source.liveIsAvailable">
          <div class="live-player-container">
            <ng-container *ngTemplateOutlet="sourceView"></ng-container>
          </div>
        </ng-template>
      </ng-template>

      <ng-template #thumbnail>
        <ng-template [ngIf]="alarm.thumbnailUrl" [ngIfElse]="sourceView">
          <img class="alarm__thumbnail" [src]="alarm.thumbnailUrl" />
          <img
            class="alarm__thumbnail__secondary"
            *ngIf="alarm.details['Patch Image']"
            [src]="alarm.details['Patch Image']"
            style="width: 100%"
          />
          <ng-template [ngIf]="alarm.source && alarm.source.liveIsAvailable">
            <div class="alarm-preview-player">
              <ng-container *ngTemplateOutlet="sourceView"></ng-container>
            </div>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>

    <ng-container [ngSwitch]="alarm.type">
      <ng-template ngSwitchCase="Amber Alert">
        <sn-amber-alert-details
          [alarm]="alarm"
          class="amber-details"
          interactive="false"
          [class.isClosedDetails]="isClosed"
        ></sn-amber-alert-details>
        <div class="child-image">
          <img matCardImage [src]="alarm.details['personList'][0].imageUrl" alt="'map.alarmCard.missingChild' | t" />
        </div>
      </ng-template>
      <ng-template ngSwitchDefault>
        <ng-container>
          <div class="alarm__details">
            <mat-list interactive="false" [class.isClosedDetails]="isClosed">
              <mat-list-item class="alarm-list-item" *ngIf="alarm.ackedBy">
                <div mat-line>{{ alarm.ackedBy.fullName }}</div>
              </mat-list-item>
              <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchDefault>
                  <ng-container
                    *ngFor="let item of alarm.details | keyvalue; trackBy: trackDetailItem"
                  >
                    <ng-container [ngSwitch]="true">
                      <ng-container *ngSwitchCase="isObject(item.value)">
                        <mat-list class="alarm__details__text">
                          <span class="alarm-layer-key">{{ item.key }}</span>
                          <ng-container *ngIf="item.key === 'layerData'">
                            <div
                              *ngFor="let detail of item.value | keyvalue : originalOrder"
                              class="wrapper"
                            >
                              <li>
                                <span class="alarms_details_key">{{ detail.key }}:</span>
                                {{ detail.value }}
                              </li>
                            </div>
                          </ng-container>
                        </mat-list>
                      </ng-container>
                      <ng-container *ngSwitchCase="isArrays(item.value)">
                        <ng-container *ngIf="item?.value?.length">
                          <mat-list>
                            <span class="alarms_details_key">{{ item.key }}</span>
                            <ng-container
                              *ngIf="item.key === 'Plate Analytics'; else recursiveTmpl"
                            >
                              <ng-container *ngFor="let detail of formatDataKeys(item.value)">
                                <mat-list-item>
                                  <div mat-line class="alarm__details__text">
                                    <div class="alarms_details_key" mat-line>{{ detail.key }}</div>
                                    <sn-text-transformer
                                      [text]="detail.value"
                                    ></sn-text-transformer>
                                  </div>
                                </mat-list-item>
                              </ng-container>
                            </ng-container>
                            <ng-template #recursiveTmpl>
                              <div
                                class="subItem"
                                *ngFor="let detail of item.value | keyvalue : originalOrder"
                              >
                                <ng-container [ngSwitch]="true">
                                  <ng-container *ngSwitchCase="isObject(detail.value)">
                                    <div
                                      *ngFor="
                                        let subItem of detail.value | keyvalue : originalOrder
                                      "
                                    >
                                      <li *ngIf="canSeeDetail(alarm.type, subItem.key)">
                                        <span class="alarms_details_key">{{ subItem.key }}:</span>
                                        {{ subItem.value }}
                                      </li>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngSwitchCase="isArrays(detail.value)">
                                    <ng-container *ngIf="detail?.value?.length">
                                      <ul class="secondaryList">
                                        <div
                                          class="subItem"
                                          *ngFor="
                                            let subItem of detail.value | keyvalue : originalOrder
                                          "
                                        >
                                          <div
                                            *ngFor="
                                              let subItem2 of subItem.value
                                                | keyvalue : originalOrder
                                            "
                                          >
                                            <li
                                              class="alarm__details__text"
                                              *ngIf="canSeeDetail(alarm.type, subItem2.key)"
                                            >
                                              <span class="alarms_details_key"
                                                >{{ subItem2.key }}:</span
                                              >
                                              {{ subItem2.value }}
                                            </li>
                                          </div>
                                        </div>
                                      </ul>
                                    </ng-container>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                    <mat-list-item class="alarm__details__text">
                                      <div mat-line>
                                        <div class="alarms_details_key" mat-line>
                                          {{ detail.key }}
                                        </div>
                                        <sn-text-transformer
                                          [text]="detail.value"
                                        ></sn-text-transformer>
                                      </div>
                                    </mat-list-item>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </ng-template>
                          </mat-list>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <mat-list-item
                          class="alarm-details-item"
                          *ngIf="canSeeDetail(alarm.type, item.key)"
                        >
                          <div mat-line>
                            <div class="alarms_details_key" mat-line>
                              {{ toStartCase(item.key) }}
                            </div>
                            <ng-container *ngIf="isTimestamp(item.value); else defaultText">
                              <ng-container [ngSwitch]="true">
                                <ng-container
                                  *ngSwitchCase="
                                    item.key?.toLowerCase() === 'last started' ||
                                    item.key?.toLowerCase() === 'last stopped'
                                  "
                                  ><span
                                    [innerHTML]="item.value * 1000 | fsFormatDate : 'medium'"
                                  ></span
                                ></ng-container>
                                <ng-container *ngSwitchDefault
                                  ><span [innerHTML]="item.value | fsFormatDate : 'medium'"></span
                                ></ng-container>
                              </ng-container>
                            </ng-container>
                            <ng-template #defaultText>
                              <sn-text-transformer
                                [text]="item.value ? item.value : 'N/A'"
                              ></sn-text-transformer>
                            </ng-template>
                          </div>
                        </mat-list-item>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="alarm.type.toLowerCase().indexOf('alpr') > -1">
                  <fs-alpr-details [alarm]="alarm"></fs-alpr-details>
                </ng-container>
              </ng-container>
            </mat-list>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
  </mat-card-content>

  <mat-card-content class="alarm__footer">
    <div class="alarm-footer-item" *ngIf="alarmTypes()">
      <sn-icon size="sm" class="small-icon">directions_car</sn-icon>
      <span [class.alarm_plate_state_missing_text]="!alarm.details.plateState">{{
        alarm.details.plateState || '— —'
      }}</span>
      <span class="alarm_plate_state_separator">⦁</span>
      <span [class.alarm_plate_state_missing_text]="!alarm.details.plate">{{
        alarm.details.plate || '— — — — — — —'
      }}</span>
    </div>
    <div class="alarm-footer-item" *ngIf="alarm.message">
      <sn-icon size="sm" class="small-icon">message</sn-icon>
      {{ alarm.message }}
    </div>
    <div class="alarm-footer-item" *ngIf="alarm.description">
      <sn-icon size="sm" class="small-icon">message</sn-icon>
      {{ alarm.description }}
    </div>
    <div class="alarm-footer-update">
      <sn-icon size="sm" class="small-icon">update</sn-icon>
      {{ alarm.updatedAt | snTimeToNow }}
      <ng-template [ngIf]="alarm.count > 1">
        <mat-divider vertical class="alarm-divider"></mat-divider>
        <sn-icon size="sm" class="small-icon">replay</sn-icon>
        {{ alarm.count }}
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #sourceView>
  <ng-container [ngSwitch]="alarm.sourceInfo?.contentType">
    <ng-template ngSwitchCase="Camera">
      <sn-audit-camera-stream-view
        *ngIf="alarm.source?.liveIsAvailable; else emptyState"
        [camera]="alarm.source"
        [autoplay]="true"
        [controls]="true"
      >
      </sn-audit-camera-stream-view>
    </ng-template>
    <ng-template ngSwitchDefault>
      <ng-container *ngTemplateOutlet="emptyState"></ng-container>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #emptyState>
  <div class="alarm__thumbnail_empty">
    <sn-icon size="xl">warning</sn-icon>
  </div>
</ng-template>

<mat-menu #alertMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-alarm="alarm">
    <button mat-menu-item (click)="turn()" *ngIf="!isFlipped">
      <sn-icon>info</sn-icon>
      <span>{{ 'common.details' | t }}</span>
    </button>
    <button *ngIf="isLprImage" mat-menu-item (click)="openEnlargedImageDialog()">
      <sn-icon>open_in_new</sn-icon>
      <span>{{ 'map.alarmCard.menu.enlargeImage' | t }}</span>
    </button>
    <button mat-menu-item (click)="turn()" *ngIf="isFlipped && alarm.type === 'Amber Alert'">
      <sn-icon>panorama</sn-icon>
      <span>{{ 'map.alarmCard.menu.image' | t }}</span>
    </button>
    <button mat-menu-item (click)="turn()" *ngIf="isFlipped && hasAlarmPlayer">
      <sn-icon>visibility</sn-icon>
      <span>{{ 'common.preview' | t }}</span>
    </button>
    <button mat-menu-item (click)="openAlarmGrid()">
      <sn-icon>apps</sn-icon>
      <span>{{ 'common.grid' | t }}</span>
    </button>
    <ng-container *ngIf="!isInMap && alarm.geometry && hasCoordinates">
      <button mat-menu-item (click)="goToAlarm.next(alarm)" *ngIf="!isInMap && alarm.geometry">
        <sn-icon>gps_fixed</sn-icon>
        <span>{{ 'common.showOnMap' | t }}</span>
      </button>
      <button *ngIf="autoDockMaxCameras > 0" mat-menu-item (click)="dockCameras.next(alarm)">
        <sn-icon>videocam</sn-icon>
        <span>{{ 'common.dockCameras' | t }}</span>
      </button>
    </ng-container>
    <!-- <button mat-menu-item (click)="openLPRStats(alarm.details['Camera Name'])">
      <sn-icon fontSet="fal" fontIcon="fa-chart-simple"></sn-icon>
      <span>{{ 'map.alarmCard.menu.lprStats' | t }}</span>
    </button> -->
    <button
      mat-menu-item
      *ngIf="
        alarm.type === 'SoundThinking' &&
        alarm.details.shotLocations &&
        alarm.details.shotLocations.length > 1
      "
      (click)="viewShotHistory.next(alarm)"
    >
      <sn-icon fontSet="fs" fontIcon="Icon_ShotSpotter"></sn-icon>
      <span>{{ 'map.alarmCard.menu.shotHistory' | t }}</span>
    </button>
    <button mat-menu-item (click)="openSendForm(alarm)">
      <sn-icon>send</sn-icon>
      <span>{{ 'map.alarmCard.menu.sendTo' | t }}</span>
    </button>
    <button mat-menu-item (click)="sendImg()" *ngIf="alarm.type.toLowerCase().indexOf('alpr') > -1">
      <sn-icon size="md">content_cut</sn-icon>
      <span>{{ 'map.alarmCard.menu.sendScreenshot' | t }}</span>
    </button>
    <button
      mat-menu-item
      *ngIf="alarm.type === 'Shooter Detection Systems'"
      (click)="viewIncident.next(alarm)"
    >
      <sn-icon>report_problem</sn-icon>
      <span>{{ 'map.alarmCard.menu.viewIncident' | t }}</span>
    </button>
    <button mat-menu-item *ngIf="alarm.type === 'LPR'" (click)="searchPlateReads(alarm)">
      <sn-icon fontSet="fal" fontIcon="fa-search"></sn-icon>
      <span>{{ 'map.alarmCard.menu.searchLast30Days' | t }}</span>
    </button>
    <button *ngIf="canChangeAlarms && !isClosed" mat-menu-item (click)="close(alarm)">
      <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
      <span>{{ 'common.close' | t }}</span>
    </button>
  </ng-template>
</mat-menu>
